module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.bfaf1857.woff2";